import { get, post } from '../../utils/request'

// banner图接口(Interface Hea Banner Api Controller)
const bannerIe = get('/news/heaBanner/api/list')

// 获取公司要闻列表(Interface Hea Group Api Controller)
const groupLtIe = get('/news/heaGroup/api/numberList')

// 获取行业资讯列表(Hea Media Api Controller)
const industryLtIe = get('/news/heaMedia/api/numberList')

// 获取项目动态列表(Interface Hea Project Api Controller)
const projectLtIe = get('/news/heaProject/api/numberList')

// 获取党风廉政(Interface Hea Clean Government Api Controller)
const cleanGtLtIe = get('/partyBuilding/heaCleanGovernment/api/list')

// 获取党建动态
const partyStyleIe = get('/partyBuilding/heaThematicLearning/api/list')
export {
  bannerIe,
  groupLtIe,
  projectLtIe,
  cleanGtLtIe,
  industryLtIe,
  partyStyleIe
}






// WEBPACK FOOTER //
// ./src/api/Home/home.js